export default "__VITE_ASSET__D4PFxzL___"